if (!customElements.get('card-gallery')) {
  customElements.define(
    'card-gallery',
    class CardGallery extends HTMLElement {
      constructor() {
        super();

        /** @type {HTMLElement | null} */
        this.gallery = this.querySelector('[data-gallery]');

        /** @type {HTMLElement | null} */
        this.scrollbar = this.querySelector('[data-gallery-scrollbar]');

        /** @type {HTMLElement | null} */
        this.next = this.querySelector('[data-gallery-next]');

        /** @type {HTMLElement | null} */
        this.prev = this.querySelector('[data-gallery-prev]');

        /** @type {import('swiper').Swiper | null} */
        this.instance = null;

        /** @type {HTMLImageElement[]} */
        this.images = Array.from(this.querySelectorAll('img'));

        /** @type {HTMLVideoElement[]} */
        this.videos = Array.from(this.querySelectorAll('video'));
      }

      connectedCallback() {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.init();

              observer.unobserve(this);
            }
          });
        });

        observer.observe(this);
      }

      init() {
        const swiper = window.swiper.Swiper;

        if (this.gallery && this.scrollbar) {
          this.instance = new swiper(this.gallery, {
            modules: [window.swiper.Scrollbar, window.swiper.Navigation],
            cssMode: true,
            slidesPerView: 1,
            spaceBetween: 1,
            scrollbar: {
              el: this.scrollbar,
              hide: false,
            },
            navigation: {
              nextEl: this.next,
              prevEl: this.prev,
            },
            on: {
              slideChange: (s) => {
                window.gtag('event', 'media_gallery_slide_change', {
                  card_index: Array.from(this.closest('.card-grid')?.querySelectorAll('.card-grid-item') || []).indexOf(
                    this.closest('.card-grid-item') || this,
                  ),
                  slide_index: s.activeIndex + 1,
                  page_path_clean: window.location.pathname.replace(/\/$/, ''),
                });

                this.images.forEach((image) => {
                  if (image && image.getAttribute('loading') !== 'eager') image.setAttribute('loading', 'eager');
                });

                this.videos.forEach((video) => {
                  if (video && video.getAttribute('preload') !== 'metadata') video.setAttribute('preload', 'metadata');
                });

                const video = s.slides[s.activeIndex].querySelector('video');

                if (video) {
                  video.muted = true;
                  video.play();
                }
              },
            },
          });
        }
      }
    },
  );
}
